import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-i_down",
  "use": "icon-i_down-usage",
  "viewBox": "0 0 34.02 34.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 34.02\" id=\"icon-i_down\"><title>icon_画板</title><path d=\"M25.72,13.21a1.12,1.12,0,0,1-.33.79L17.8,21.59a1.11,1.11,0,0,1-1.58,0L8.62,14a1.12,1.12,0,0,1,1.58-1.58L17,19.23l6.81-6.81a1.12,1.12,0,0,1,1.57,0A1.11,1.11,0,0,1,25.72,13.21Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol